import React from "react";
import Save from "../assets/save.svg"; 

const SaveSVG = ({width, height, ...props}) => {
    return (
        <div>
             <img src={Save} alt="Expand" style={{ width: width, height: height }} {...props}/>
        </div>
    ); 
}; 

export default SaveSVG; 